var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconXExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9795 1.98053C11.2724 1.68763 11.2724 1.21276 10.9795 0.919865C10.6867 0.626972 10.2118 0.626972 9.91889 0.919865L5.94922 4.88954L1.97955 0.919865C1.68666 0.626972 1.21178 0.626972 0.918889 0.919865C0.625996 1.21276 0.625996 1.68763 0.918889 1.98053L4.88856 5.9502L0.918889 9.91987C0.625995 10.2128 0.625995 10.6876 0.918889 10.9805C1.21178 11.2734 1.68666 11.2734 1.97955 10.9805L5.94922 7.01085L9.91889 10.9805C10.2118 11.2734 10.6867 11.2734 10.9795 10.9805C11.2724 10.6876 11.2724 10.2128 10.9795 9.91987L7.00988 5.9502L10.9795 1.98053Z",
    fill: "#525D71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXExit);
export default __webpack_public_path__ + "static/media/icon-x-exit.09c767026a9e71c6634953d7c2e04011.svg";
export { ForwardRef as ReactComponent };